import { Award, TrendingUp } from "lucide-react";

const ArticleLearn = () => {
  const learningItems = [
    {
      title: "LinkedIn You'll Love",
      description: "Transform your LinkedIn profile from basic to boss-level.",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      ),
      color: "blue",
    },
    {
      title: "Resume Rescue Squad",
      description:
        "Build a CV that actually stands out—no more template traps!",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      ),
      color: "indigo",
    },
    {
      title: "Cold Mailing Skills",
      description: 'Land responses (not just "seen" status).',
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
      color: "purple",
    },
    {
      title: "Referrals Made Easy",
      description:
        "Learn how to ask for and get referrals that open real doors.",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
      ),
      color: "emerald",
    },
    {
      title: "Ace Those Interviews",
      description: "All the tips you'll need minus the anxiety sweats.",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      color: "amber",
    },
    {
      title: "Industry Insights",
      description:
        "Attend live sessions with experienced professionals from diverse fields.",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
          />
        </svg>
      ),
      color: "orange",
    },
    {
      title: "Job Alerts",
      description:
        "Get the latest articleship openings straight to your inbox.",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 17h5l-5 5v-5zM4 19h6v-2H4v2zM4 15h8v-2H4v2zM4 11h8V9H4v2zM4 7h8V5H4v2z"
          />
        </svg>
      ),
      color: "cyan",
    },
    {
      title: "Ongoing Referral Help",
      description: "Our support doesn't end until you secure your articleship.",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
      ),
      color: "rose",
    },
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: "bg-blue-500/10 border-blue-500/30 text-blue-400 group-hover:border-blue-500/50 group-hover:text-blue-300",
      indigo:
        "bg-indigo-500/10 border-indigo-500/30 text-indigo-400 group-hover:border-indigo-500/50 group-hover:text-indigo-300",
      purple:
        "bg-purple-500/10 border-purple-500/30 text-purple-400 group-hover:border-purple-500/50 group-hover:text-purple-300",
      emerald:
        "bg-emerald-500/10 border-emerald-500/30 text-emerald-400 group-hover:border-emerald-500/50 group-hover:text-emerald-300",
      amber:
        "bg-amber-500/10 border-amber-500/30 text-amber-400 group-hover:border-amber-500/50 group-hover:text-amber-300",
      orange:
        "bg-orange-500/10 border-orange-500/30 text-orange-400 group-hover:border-orange-500/50 group-hover:text-orange-300",
      cyan: "bg-cyan-500/10 border-cyan-500/30 text-cyan-400 group-hover:border-cyan-500/50 group-hover:text-cyan-300",
      rose: "bg-rose-500/10 border-rose-500/30 text-rose-400 group-hover:border-rose-500/50 group-hover:text-rose-300",
    };
    return colors[color] || colors.blue;
  };

  return (
    <div className="bg-black py-20 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/30 backdrop-blur-sm">
            <TrendingUp className="w-4 h-4 text-blue-400" />
            <span className="text-sm font-semibold text-blue-400 tracking-wide uppercase">
              what you'll master
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 mt-12">
            What You'll Learn{" "}
            <span className="text-transparent bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text">
              (and Get!)
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            A comprehensive toolkit designed to transform your articleship
            journey
          </p>
        </div>

        {/* Learning Items Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
          {learningItems.map((item, index) => (
            <div
              key={index}
              className="bg-gradient-to-b from-gray-900 to-gray-800 border border-gray-700 rounded-xl p-6 hover:border-gray-600 transition-all duration-300 group"
            >
              <div className="flex items-start gap-4">
                <div
                  className={`w-12 h-12 rounded-xl border flex items-center justify-center flex-shrink-0 transition-all duration-300 ${getColorClasses(
                    item.color
                  )}`}
                >
                  {item.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg text-left font-semibold text-white mb-2 group-hover:text-gray-100 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 text-left leading-relaxed group-hover:text-gray-300 transition-colors">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center gap-3 bg-gray-900/50 border border-gray-700 rounded-lg px-6 py-4">
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
              <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
            </div>
            <span className="text-gray-300 font-medium">
              Complete articleship preparation toolkit
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleLearn;
